import WebGalleryAlbumFolderContainer from './WebGalleryAlbumFolderContainer';

export default WebGalleryAlbumFolderContainer;
